import { putData } from "../backend";
import { Team, TeamUser } from "../interfaces";
import useUser from "../hooks/useUser";
import Avatar from "./Avatar";
import moment from "moment";
import SettingsTeamUserRole from "./SettingsTeamUserRole";
import { useState } from "react";


interface Props {
  team: Team;
  user: TeamUser;
  onRemove?: () => void;
}

function SettingsTeamUser(props: Props) {
  const { user: teamUser } = props;
  const { refreshUser } = useUser();

  const [isUpdating, setIsUpdating] = useState(false);

  async function handleRemoveUser() {
    setIsUpdating(true);
    try {
      const newTeam = await putData(`/auth/team/remove/`, { user: teamUser.id })
      refreshUser((user: any) => ({ ...user, newTeam }));
    } catch (error) {
      console.error(error)
    } finally {
      setIsUpdating(false);
      props?.onRemove?.();
    }
  }

  function handleChangeUserRole(role: string) {
    setIsUpdating(true);
    putData(`/auth/team/change-user-role/`, { user: teamUser.id, role })
      .then((team: Team) => {
        refreshUser((user: any) => ({ ...user, team }));
        props?.onRemove?.();
      })
      .catch(console.error)
      .finally(() => setIsUpdating(false));
  }

  return (
    <tr>
      <td className="w-auto">
        <div className="flex items-center gap-2 text-sm my-2">
          <Avatar url={teamUser.avatar} className="h-10 w-10 flex-shrink-0" />
          <div className="flex flex-col">
            <p className="font-gilroy font-bold whitespace-nowrap overflow-hidden text-ellipsis">{teamUser.fullName}</p>
            <p className="text-gray-400 whitespace-nowrap overflow-hidden text-ellipsis">{teamUser.email}</p>
          </div>
        </div>
      </td>
      <td className="w-[200px]">
        <div className="w-40">
          <SettingsTeamUserRole teamUser={teamUser} role={teamUser.teamRole} onSelectRole={handleChangeUserRole} onRemove={handleRemoveUser} isUpdating={isUpdating} />
        </div>
      </td>
      <td className="text-gray-400 text-sm text-center w-[200px]">
        {teamUser.usage}
      </td>
      <td className="text-gray-400 text-sm text-left w-[200px]">
        {moment(teamUser.dateLastLogin).format("MMM D, h:mma")}
      </td>
    </tr>
  );
}

export default SettingsTeamUser;
